import { render, staticRenderFns } from "./EditGiftCard.vue?vue&type=template&id=3e8e3670&"
import script from "./EditGiftCard.vue?vue&type=script&lang=js&"
export * from "./EditGiftCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports